module.exports = __webpack_public_path__ + "img/restauran.26676878.png";